// @flow

import React, { Fragment } from "react";

import { Icon } from "../../icons";
import { Tooltip } from "../../tooltip";

import AbstractToolboxItem from "./AbstractToolboxItem";
import type { Props as AbstractToolboxItemProps } from "./AbstractToolboxItem";
import { connect } from "../../redux";

type Props = AbstractToolboxItemProps & {
    /**
     * On key down handler.
     */
    onKeyDown: Function,
    _isModeratorCheckAhmad: Object,
};

/**
 * Web implementation of {@code AbstractToolboxItem}.
 */
class ToolboxItem extends AbstractToolboxItem<Props> {
    /**
     * Initializes a new {@code ToolboxItem} instance.
     *
     * @inheritdoc
     */
    constructor(props: Props) {
        super(props);
        // console.log("yecalled",this.props._isModeratorCheckAhmad?.moderatorJwt)

        this._onKeyPress = this._onKeyPress.bind(this);
    }

    _onKeyPress: (Object) => void;

    /**
     * Handles 'Enter' and Space key on the button to trigger onClick for accessibility.
     *
     * @param {Object} event - The key event.
     * @private
     * @returns {void}
     */
    _onKeyPress(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            this.props.onClick();
        }
    }

    /**
     * Handles rendering of the actual item. If the label is being shown, which
     * is controlled with the `showLabel` prop, the item is rendered for its
     * display in an overflow menu, otherwise it will only have an icon, which
     * can be displayed on any toolbar.
     *
     * @protected
     * @returns {ReactElement}
     */
    _renderItem() {
        const {
            disabled,
            elementAfter,
            onClick,
            onKeyDown,
            showLabel,
            tooltipPosition,
            toggled,
        } = this.props;
        const val = sessionStorage.getItem("isModerator");
        console.log("valll", val);
        // const val=sessionStorage.getItem("isModerator");
        // console.log("propsss",this.props._isModeratorCheckAhmad.moderatorJwt)

        // console.log("propsss1",this.props.buttonKey=='invite'&&!this.props._isModeratorCheckAhmad?.moderatorJwt===true)
        if (
            (this.props.buttonKey == "invite" && val === null) ||
            (this.props.buttonKey == "select-background" && val === null) ||
            (this.props.buttonKey == "camera" && val === null) ||
            (this.props.buttonKey == "desktop" && val === null) ||
            (this.props.buttonKey == "toggle-camera" && val === null)
        )
            return null;

        // if(this.props.buttonKey=='invite'&&!this.props._isModeratorCheckAhmad?.moderatorJwt===true ||this.props.buttonKey=='select-background'&&!this.props._isModeratorCheckAhmad?.moderatorJwt===true )
        // return null

        const className = showLabel ? "overflow-menu-item" : "toolbox-button";

        let props = {
            "aria-pressed": toggled,
            "aria-disabled": disabled,
            "aria-label": this.accessibilityLabel,
            className: className + (disabled ? " disabled" : ""),
            onClick: disabled ? undefined : onClick,
            onKeyDown: disabled ? undefined : onKeyDown,
            onKeyPress: this._onKeyPress,
            tabIndex: 0,
            role: showLabel ? "menuitem" : "button",
        };
        //         if(this.props.buttonKey=='invite')
        //         {
        // props={}
        //         }
        //         else{
        //             props = {
        //             'aria-pressed': toggled,
        //             'aria-disabled': disabled,
        //             'aria-label': this.accessibilityLabel,
        //             className: className + (disabled ? ' disabled' : ''),
        //             onClick: disabled ? undefined : onClick,
        //             onKeyDown: disabled ? undefined : onKeyDown,
        //             onKeyPress: this._onKeyPress,
        //             tabIndex: 0,
        //             role: showLabel ? 'menuitem' : 'button'
        //         };
        // }
        const elementType = showLabel ? "li" : "div";
        const useTooltip = this.tooltip && this.tooltip.length > 0;
        let children = (
            <Fragment>
                {this._renderIcon()}
                {showLabel && <span>{this.label}</span>}
                {elementAfter}
            </Fragment>
        );

        if (useTooltip) {
            children = (
                <Tooltip content={this.tooltip} position={tooltipPosition}>
                    {children}
                </Tooltip>
            );
        }

        return React.createElement(elementType, props, children);
    }

    /**
     * Helper function to render the item's icon.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderIcon() {
        const { customClass, disabled, icon, showLabel, toggled } = this.props;
        const iconComponent = <Icon src={icon} />;
        const elementType = showLabel ? "span" : "div";
        const className = `${
            showLabel ? "overflow-menu-item-icon" : "toolbox-icon"
        } ${toggled ? "toggled" : ""} ${disabled ? "disabled" : ""} ${
            customClass ?? ""
        }`;

        return React.createElement(elementType, { className }, iconComponent);
    }
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code ParticipantsCount} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state) {
    console.log("ToolboxItem", state);
    return {
        _isModeratorCheckAhmad: state["features/base/jwt"],
    };
}
export default connect(mapStateToProps)(ToolboxItem);
